module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/xml-dededb26271bd794e7995c614fce8331.svg";